// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body { 
  overflow-y: auto; 
  height: 100%;
}

.AccountCreation_accountCreation__w0on7 {
  width: 100vw;
  min-height: 100dvh;
  background-color: var(--color-bg-login);
}

.AccountCreation_accountCreationContainer__FuIK3 {
  width: 880px;
  height: 690px;
  display: flex;
  flex-direction: column;
  margin-left: auto;
  margin-right: auto;
  padding: 20px 60px 0 60px;
  background-color: var(--color-bg-login-box);
  box-shadow: 0px 3px 6px var(--color-theme-cloud);
}

.AccountCreation_accountCreationHeader__mCgYk {
  font-weight: bold;
  font-size: 22px;
  margin-bottom: 35px;
  color: var(--color-font-2);
}

/* Disable scroll on MacBook Air (13") and bigger */
@media screen and (min-width: 1440px) {
  html, body {
    overflow-y: hidden;
  }

  .AccountCreation_accountCreation__w0on7 {
    height: 100vh;
  }

   .AccountCreation_accountCreationContainer__FuIK3 {
    position: fixed;
    top: calc(50% + 40px);
    left: 50%;
    transform: translate(-50%, -50%);
  }
}`, "",{"version":3,"sources":["webpack://./src/@_pages/AccountCreation/AccountCreation.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,2CAA2C;EAC3C,gDAAgD;AAClD;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,mDAAmD;AACnD;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;GAEC;IACC,eAAe;IACf,qBAAqB;IACrB,SAAS;IACT,gCAAgC;EAClC;AACF","sourcesContent":["html, body { \n  overflow-y: auto; \n  height: 100%;\n}\n\n.accountCreation {\n  width: 100vw;\n  min-height: 100dvh;\n  background-color: var(--color-bg-login);\n}\n\n.accountCreationContainer {\n  width: 880px;\n  height: 690px;\n  display: flex;\n  flex-direction: column;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 20px 60px 0 60px;\n  background-color: var(--color-bg-login-box);\n  box-shadow: 0px 3px 6px var(--color-theme-cloud);\n}\n\n.accountCreationHeader {\n  font-weight: bold;\n  font-size: 22px;\n  margin-bottom: 35px;\n  color: var(--color-font-2);\n}\n\n/* Disable scroll on MacBook Air (13\") and bigger */\n@media screen and (min-width: 1440px) {\n  html, body {\n    overflow-y: hidden;\n  }\n\n  .accountCreation {\n    height: 100vh;\n  }\n\n   .accountCreationContainer {\n    position: fixed;\n    top: calc(50% + 40px);\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"accountCreation": `AccountCreation_accountCreation__w0on7`,
	"accountCreationContainer": `AccountCreation_accountCreationContainer__FuIK3`,
	"accountCreationHeader": `AccountCreation_accountCreationHeader__mCgYk`
};
export default ___CSS_LOADER_EXPORT___;
